module.exports = __webpack_public_path__ + "img/prize-distribution-time.47805e45.svg";